import { createAction } from '@reduxjs/toolkit';

export const requestVerifyUser = createAction('request/verifyUser');
export const requestUploadVerificationDocument = createAction('request/uploadVerificationDocument');
export const requestDeleteVerificationDocument = createAction('request/deleteVerificationDocument');
export const requestAddBrokerRole = createAction('request/addBrokerRole');
